import angular from 'angular';
import { MERCHANT_PORTAL_API_BASE_URL } from '../../core/main/controller/environment';
import { format } from 'date-fns';

const dateFormat = "yyyy-MM-dd";
const baseUrl = `${MERCHANT_PORTAL_API_BASE_URL}/portal/merchants`;

export const getOnlineCardInvoiceUrl = (merchantId, startDate, endDate, type) => {
    const start = format(startDate, dateFormat);
    const end = format(endDate, dateFormat);
    return `${baseUrl}/${merchantId}/${type}?start=${start}&end=${end}`;
};


angular.module("merchant.application.main").factory("merchant.application.main.factory.onlineCardTaxInvoice", [
    function() {
        var expose = {};

        expose.getOnlineCardInvoiceUrl = getOnlineCardInvoiceUrl;

        return expose;
    }
]);
